<h3>{{ getTitle(calendar) }}</h3>
<div [innerHTML]="getTranslated(calendar,'description')"></div>
<button class="cta cta--small" (click)="prev()"><i class="ico-angle-left"></i></button> {{ date | date:'MM y' }} <button class="cta cta--small" (click)="next()"><i class="ico-angle-right"></i></button>
<button class="cta cta--green" style="float:right;" [routerLink]="['/appointments/holidays/add/' + id]">Přidat volno <i class="ico-plus"></i></button>
<div class="appointments">
    <ng-container *ngIf="calendar && days">
        <div *ngFor="let day of days" class="appointments__day">
            <swb-appointments-calendar [data]="{ day: day, calendar: calendar }">
            </swb-appointments-calendar>
        </div>
    </ng-container>
    <div *ngIf="loading">Loading...</div>
</div>